import React from 'react';
import { Lock } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';

export default function LockedOverlay({ isLocked = false, size = 'default' }) {
  const { isDarkMode } = useTheme();
  
  if (!isLocked) return null;

  const sizeClasses = {
    small: 'w-8 h-8',
    default: 'w-12 h-12 sm:w-16 sm:h-16',
    large: 'w-16 h-16 sm:w-20 sm:h-20'
  };

  const iconSizes = {
    small: 'w-4 h-4',
    default: 'w-6 h-6 sm:w-8 sm:h-8',
    large: 'w-8 h-8 sm:w-10 sm:h-10'
  };

  // In dark mode, use black icon for maximum contrast against white background
  // In light mode, use dark gray
  const iconColor = isDarkMode ? '#000000' : '#374151';

  return (
    <div 
      className="absolute inset-0 rounded-lg flex items-center justify-center z-10 pointer-events-none"
      style={{ backgroundColor: isDarkMode ? 'rgba(0,0,0,0.35)' : 'rgba(0,0,0,0.1)' }}
    >
      <div 
        className={`${sizeClasses[size]} rounded-full flex items-center justify-center`}
        style={{ 
          backgroundColor: '#ffffff',
          border: '2px solid #6b7280',
          boxShadow: '0 4px 14px rgba(0,0,0,0.3)'
        }}
      >
        <Lock 
          className={iconSizes[size]} 
          color={iconColor}
          strokeWidth={2.5}
        />
      </div>
    </div>
  );
}
